module.exports = new __parcel__URL__("check-circle-outline.df28afef.svg").toString();